<script lang="ts">
    import { _ } from "svelte-i18n";
</script>

<section class="py-8 py-md-11 bg-white border-bottom">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-md-8 text-center">
                <span class="badge badge-pill badge-primary-soft mb-3">
                    <span class="h6 text-uppercase"
                        >{$_("pricing.faq.tag1")}</span>
                </span>

                <h2>{$_("pricing.faq.title")}</h2>

                <p class="fs-lg text-muted mb-7 mb-md-9">
                    {$_("pricing.faq.subtitle")}
                </p>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q1.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q1.a1")}
                            <a href="https://www.openstreetmap.org/"
                                >OpenStreetMap (OSM)</a
                            >{$_("pricing.faq.q1.a2")}
                        </p>
                    </div>
                </div>
                
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q2.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q2.a")}
                        </p>
                    </div>
                </div>
                
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q3.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q3.a")}
                        </p>
                    </div>
                </div>
                
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q4.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q4.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q10.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q10.a")}
                        </p>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6">
                
                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q5.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q5.a1")}
                            <a href="https://github.com/anyways-open/impact-qgis-plugin"
                                >{$_("pricing.faq.q5.a2")}</a>
                            {$_("pricing.faq.q5.a3")}
                            <a href="https://qgis.org">{$_("pricing.faq.q5.a4")}</a>
                            {$_("pricing.faq.q5.a5")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q6.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q6.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q7.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q7.a")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q8.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q8.a1")}
                            <a href="https://www.anyways.eu/map/#12.96/50.84577/4.33054"
                                >{$_("general.mde")}
                            </a>{$_("pricing.faq.q8.a2")}
                        </p>
                    </div>
                </div>

                <div class="d-flex">
                    <div class="badge badge-lg badge-rounded-circle bg-secondary">
                        <span>?</span>
                    </div>
                    <div class="ms-5">
                        <h4>
                            {$_("pricing.faq.q9.q")}
                        </h4>
                        <p class="text-muted mb-6 mb-md-8">
                            {$_("pricing.faq.q9.a")}
                        </p>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</section>
